import getToken from '../../../../utility/getToken';
import Logger from '../../../../utility/services/Logger';
import UserDocumentsControllerImage from '../../../../utility/userDocumentsImageController';

export default async ({
  event,
  documentId,
  formatType,
  resumeType,
  userId,
  selectedPlan = null,
  universityPlan = null,
  currentImportStreamId = null,
}) => {
  return new Promise((resolve, reject) => {
    const file = event.target.files[0];
    const reader = new FileReader();
    reader.onloadend = async () => {
      try {
        const base64File = reader.result;
        const token = await getToken();
        const data = {
          documentId,
          formatType,
          resumeType,
          userId,
          fileData: base64File,
          selectedPlan,
          universityPlan,
          currentImportStreamId,
        };
        const importDocumentData =
          await UserDocumentsControllerImage.importDocumentStream(token, data);
        resolve(importDocumentData);
      } catch (error) {
        Logger.LogError(error);
        reject(error);
      }
    };
    reader.onerror = (error) => reject(error);
    reader.readAsDataURL(file);
  });
};
